import React, { useState } from 'react';
import { Card, CardContent, Typography, Grid, Chip, Box, Link, Button } from '@mui/material';
import { projects } from '../data/projects';

const Projects = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 5;

  const totalPages = Math.ceil(projects.length / ITEMS_PER_PAGE);

  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentProjects = projects.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  return (
      <Card sx={{ borderRadius: 2 }}>
        <CardContent>
          <center>
            <Typography variant="h5" style={{ textDecoration: 'none', marginBottom: '0px' }}>My Projects</Typography>
          </center>
          <hr />
        </CardContent>
        <CardContent style={{minHeight: '900px'}}>
          {currentProjects.map((project, index) => (
            <Box key={index} display="flex" flexDirection="column" mb={2}>
              <Box display="flex" alignItems="center">
                <img src={project.image} style={{ height: '100px', width: '100px', marginRight: '16px', borderRadius: 2 }} alt={project.name} />
                <Box>
                <Typography variant="body2" fontWeight="bold" fontSize="1.2rem" style={{textDecoration: 'underline'}}>
                  <Link href={project.link} target="_blank" rel="noopener" color="inherit" underline="none">
                    {project.name}
                  </Link>
                </Typography>
                  <Typography variant="body2">
              {project.timeframe}
            </Typography>
                  <Typography variant="body2">
                    {project.description}
                  </Typography>
                </Box>
              </Box>
              <Box display="flex" flexWrap="wrap" mt={1} justifyContent="flex-end">
                {project.technologies.map((tech, techIndex) => (
                  <Chip key={techIndex} label={tech} size="small" sx={{ mr: 1, mb: 1 }} />
                ))}
              </Box>
            </Box>
          ))}
          </CardContent>
          <CardContent>
            <Box display="flex" justifyContent="space-between" mt={2}>
              <Button variant="contained" onClick={handlePreviousPage} disabled={currentPage === 1}>
                Previous
              </Button>
              <Typography variant="body2">
                Page {currentPage} of {totalPages}
              </Typography>
              <Button variant="contained" onClick={handleNextPage} disabled={currentPage === totalPages}>
                Next
              </Button>
            </Box>
        </CardContent>
      </Card>
  );
};

export default Projects;